import * as React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
  months: number;
}

const Tenure = ({ months }: IProps) => {
  const years = Math.floor(months / 12);
  months = years > 0 ? months % 12 : months;

  const { t } = useTranslation();

  const yearString =
    years === 1 ? `1 ${t("feedback.tenure.year")}` : years > 1 ? `${years} ${t("feedback.tenure.years")}` : "";

  const monthString =
    months === 1
      ? `1 ${t("feedback.tenure.month")}`
      : years && months === 0
      ? ""
      : !years && !months
      ? `${t(`feedback.tenure.recentlyJoined`, { months: 0 })}`
      : `${months} ${t("feedback.tenure.months")}`;

  return <>{yearString ? `${yearString} ${monthString}` : monthString}</>;
};

export default React.memo(Tenure);
